var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyWallet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 37,
  height: 36,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M27.56 20.325c-.63.615-.99 1.5-.9 2.445.135 1.62 1.62 2.805 3.24 2.805h2.85v1.785A5.653 5.653 0 0 1 27.11 33H9.89a5.653 5.653 0 0 1-5.64-5.64V17.265a5.653 5.653 0 0 1 5.64-5.64h17.22a5.653 5.653 0 0 1 5.64 5.64v2.16h-3.03c-.84 0-1.605.33-2.16.9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M4.25 18.615V11.76a4.27 4.27 0 0 1 2.76-4.005l11.91-4.5c1.86-.705 3.855.675 3.855 2.67v5.7M34.338 20.955v3.09c0 .825-.66 1.5-1.5 1.53h-2.94c-1.62 0-3.105-1.185-3.24-2.805-.09-.945.27-1.83.9-2.445a3 3 0 0 1 2.16-.9h3.12c.84.03 1.5.705 1.5 1.53M11 18h10.5"
})));
export default SvgEmptyWallet;